import React, { useContext, useEffect, useState } from 'react'

import { Marquee } from '../components/marquee';
import VideoPlayer from '../components/videoPlayer3';

import { useHideMenu } from '../hooks/useHideMenu';
import { UseSweetAlert } from '../hooks/useSweetAlert';
import { SocketContext } from '../context/SocketContext';
import { getUltimos } from '../helpers/getUltimos';

import { useSpeechRecognition, useSpeechSynthesis } from "react-speech-kit";

import sound from "../assets/new-ticket.mp3";

let entidad= localStorage.getItem('entidad') || null;
let videoList= localStorage.getItem('videos') || "";

// videolist = https://institutodelcorazon.com/wp-content/uploads/2023/05/foscaltv1.mp4

export const Cola2 = () => {

    useHideMenu(true);



    const { socket } = useContext( SocketContext );
    const [tickets, setTickets] = useState([]);
    const [entidadBD, setEntidadBD] = useState(null);
    const [llamadoVoz, setLlamadoVoz] = useState(0);
    
    const [minutosUltimo, setMinutosUltimo ] = useState(0);
    const [playAnimation, setPlayAnimation] = useState(false);

    const [videos, setVideos] = useState([]);
    const { speak, voices } = useSpeechSynthesis();

    const voice = voices[1];
    
    useEffect(() => {
        async function fetchData() {
            console.log(entidad);
            
            if(!entidad && entidad===null) return;
            const data= {
                codigoEntidad : entidad
            } ;
            await socket.emit('lista-videos-mostrar', data, async ( lista ) => {
                // console.log(lista);
                // setVideos( lista.map((item)=>item.videoCodigo) )
                // localStorage.setItem('videos', lista.map((item)=>item.videoCodigo));

                // console.log(videos);
                const listas =  Array.from(JSON.parse(lista[0].listaVideos));
                
                setVideos( listas.map((item)=>item.code) )
                localStorage.setItem('videos', listas.map((item)=>item.code));

                console.log(videos);

            })
        }

        fetchData();

        return () => {
            socket.off('lista-videos-mostrar')
        }
    }, [socket])

    useEffect(() => {
      
        async function fetchData() {
            if(!entidad && entidad===null) return;
           
            await socket.on('lista-videos-mostrar', async ( lista ) => {
                // console.log(lista);
                // setVideos( lista.map((item)=>item.videoCodigo) )
                // localStorage.setItem('videos', lista.map((item)=>item.videoCodigo));

                // console.log(videos);
                const listas =  Array.from(JSON.parse(lista[0].listaVideos));
                
                setVideos( listas.map((item)=>item.code) )
                localStorage.setItem('videos', listas.map((item)=>item.code));

                console.log(videos);

            })
        }

        fetchData();

        return () => {
            socket.off('lista-videos-mostrar')
        }
    }, [socket])

    // volver a llamar
    useEffect(() => {
      
        function fetchLlamado() {

            
            socket.on('volver-llamar', ( ticket ) => {

                setLlamadoVoz( ticket[0].llamadoVoz );
                localStorage.setItem('llamadoVoz', ticket[0].llamadoVoz );
                localStorage.setItem('voz', ticket[0].voz );

                const voz = ticket[0].voz;
                console.log(voz);
                

                const llamado= ticket[0].llamadoVoz;
                const audio =  new Audio(sound);
                
                const paciente = ticket[0].nombrePaciente.trim() != "" 
                ? ticket[0].nombrePaciente
                : `Turno ${ticket[0].codigoTipoAtencion} ${ticket[0].numeroTicket}`;   
            
                const modulo = ` ${ticket[0].moduloClase} ${ticket[0].modulo} `;

                const text= `${paciente} ${modulo}`; 
                
                // speak({ text, voice, rate:"0.7", pitch:"0.5" });
                console.log(llamado)
                // if(llamado == 1){
                //     const synth = window.speechSynthesis;
                //     const voices = synth.getVoices();

                //     let arr= Array();
                //     for (let i = 0; i < voices.length; i++) {
                //         const option = document.createElement("option");
                //         option.textContent = `${voices[i].name} (${voices[i].lang})`;
                //         option.value = i;
                //         arr.push({name:`${voices[i].name}`, lang:`${voices[i].lang}`});
                //     }
                    

                //     console.log(arr);
                //     socket.emit('lista-voces', {arr, entidad}, async ( rpta ) => {
                //         console.log(rpta);
                //     })

                //     // detectar los llamados de voz 
                   
                //     // console.log(utterThis);
                //     const utterThis = new SpeechSynthesisUtterance(text); 
                //     // utterThis.lang = 'es-US';

                //     console.log(typeof(voices[voz]));

                //     if( voz === "" || voices[voz]=== undefined ) utterThis.lang = 'es-US';
                //     else utterThis.voice = voices[voz];

                //     utterThis.text = text;
                //     // utterThis.text = "WILDAMIRO PARRA";
                //     // utterThis.text = "NURIAN QUITIAN";
                //     console.log(utterThis);
                //     synth.speak(utterThis)

                // }               
                // else audio.play();

                // audio.play();
                
                
                //    if(asignados.length > 0 && minutosUltimo < 0.30 ) audio.play();
                
                if (llamado == 1) {
                    const synth = window.speechSynthesis;

                    // Función para esperar a que se carguen las voces
                    const loadVoices = () => {
                        return new Promise((resolve) => {
                            let voices = synth.getVoices();
                            if (voices.length !== 0) {
                                resolve(voices);
                            } else {
                                synth.onvoiceschanged = () => {
                                    voices = synth.getVoices();
                                    resolve(voices);
                                };
                            }
                        });
                    };

                    loadVoices().then((voices) => {
                        // Buscar voz latina preferida
                        console.log(voices);
                        
                        const latinVoices = voices.filter(v => 
                            v.lang.startsWith('es') && 
                            /MX|CO|AR|ES|PE|CL|VE/.test(v.lang)
                        );

                        console.log(latinVoices);
                        
                        // Elegir voz preferida
                        let selectedVoice = latinVoices[0] || voices.find(v => v.lang.startsWith('es')) || null;
                        console.log(selectedVoice);


                        // // Si se recibió un índice de voz válido, usarlo
                        // if (voz !== "" && voices[voz]) {
                        //     selectedVoice = voices[voz];
                        // }
                        // console.log(selectedVoice);

                        const utterThis = new SpeechSynthesisUtterance(text);
                        if (selectedVoice) {
                            utterThis.voice = selectedVoice;
                        } else {
                            utterThis.lang = 'es-ES'; // fallback
                        }

                        utterThis.rate = 0.9;
                        utterThis.pitch = 1;
                        synth.speak(utterThis);

                        // // Opcional: enviar voces al servidor
                        // const arr = voices.map(v => ({ name: v.name, lang: v.lang }));
                        // socket.emit('lista-voces', { arr, entidad }, (rpta) => {
                        //     console.log(rpta);
                        // });
                    });
                } else {
                    audio.play();
                }

                
            })
        }

        fetchLlamado();

        return () => {
            socket.off('volver-llamar')
        }
    })

    useEffect(() => {
        
        async function fetchData() {
            await socket.on('ticket-asignado', ( asignados )=> {

                if(asignados.length === 0) {
                    setTickets( asignados )
                    return
                };
                
                setLlamadoVoz( asignados[0].llamadoVoz );
                localStorage.setItem('llamadoVoz', asignados[0].llamadoVoz );
                localStorage.setItem('voz', asignados[0].voz );

                const voz = asignados[0].voz;

                const llamado= asignados[0].llamadoVoz;
                const audio =  new Audio(sound);

                // setPlayAnimation( true );
                setTickets( asignados )

                if( asignados.length > 0 ) {
                    
                    const hoy = new Date();
                    const ultimo = new Date(asignados[0].atendidoEn);
                    const diferenciaEnMinutos = (hoy - ultimo) / (1000 * 60);
                    console.log( diferenciaEnMinutos )
                    setMinutosUltimo( diferenciaEnMinutos );


                    const text = asignados[0].nombrePaciente.trim() === ""
                    ? `TURNO ${asignados[0].codigoTipoAtencion} ${asignados[0].numeroTicket} ${asignados[0].moduloClase} ${asignados[0].modulo}`
                    : ` ${asignados[0].nombrePaciente} ${asignados[0].moduloClase} ${asignados[0].modulo}`;  
                    
                    if(asignados.length > 0 && diferenciaEnMinutos < 0.10 ) {
                        console.log(llamado)
                        // if(llamado == 1) speak({ text, voice, rate:"0.7", pitch:"0.5" });
                        // else audio.play();

                        // if(llamado == 1){
                        //     // speak({ text, voice, rate:"0.7", pitch:"0.5" });
        
                        //     const synth = window.speechSynthesis;
                        //     const voices = synth.getVoices();

                        //     let arr= Array();
                        //     for (let i = 0; i < voices.length; i++) {
                        //         const option = document.createElement("option");
                        //         option.textContent = `${voices[i].name} (${voices[i].lang})`;
                        //         option.value = i;
                        //         arr.push({name:`${voices[i].name}`, lang:`${voices[i].lang}`});
                        //     }
                            
        
                        //     console.log(arr);
                        //     // socket.emit('lista-voces', {arr, entidad}, async ( rpta ) => {
                        //     //     console.log(rpta);
                        //     // })
        

                        //     const utterThis = new SpeechSynthesisUtterance(text); 
                           
                        //     // utterThis.lang = 'es-US';
                        //     console.log(typeof(voices[voz]));

                        //     if( voz === "" || voices[voz]=== undefined ) utterThis.lang = 'es-US';
                        //     else utterThis.voice = voices[voz];
                           
                        //     const l = utterThis.voice

                        //     socket.emit('lista-voces', {l, entidad}, async ( rpta ) => {
                        //         console.log(rpta);
                        //     })
                           
                        //     utterThis.text = text;
                        //     console.log(utterThis);
                        //     synth.speak(utterThis)
        
                        // }               
                        // else audio.play();

                        if (llamado == 1) {
                            const synth = window.speechSynthesis;

                            // Función para esperar a que se carguen las voces
                            const loadVoices = () => {
                                return new Promise((resolve) => {
                                    let voices = synth.getVoices();
                                    if (voices.length !== 0) {
                                        resolve(voices);
                                    } else {
                                        synth.onvoiceschanged = () => {
                                            voices = synth.getVoices();
                                            resolve(voices);
                                        };
                                    }
                                });
                            };

                            loadVoices().then((voices) => {
                                // Buscar voz latina preferida
                                const latinVoices = voices.filter(v => 
                                    v.lang.startsWith('es') && 
                                    /MX|CO|AR|ES|PE|CL|VE/.test(v.lang)
                                );

                                console.log(latinVoices);
                                
                                // Elegir voz preferida
                                let selectedVoice = latinVoices[0] || voices.find(v => v.lang.startsWith('es')) || null;
                                console.log(selectedVoice);


                                // // Si se recibió un índice de voz válido, usarlo
                                // if (voz !== "" && voices[voz]) {
                                //     selectedVoice = voices[voz];
                                // }
                                // console.log(selectedVoice);

                                const utterThis = new SpeechSynthesisUtterance(text);
                                if (selectedVoice) {
                                    utterThis.voice = selectedVoice;
                                } else {
                                    utterThis.lang = 'es-ES'; // fallback
                                }

                                utterThis.rate = 0.9;
                                utterThis.pitch = 1;
                                synth.speak(utterThis);

                                // Opcional: enviar voces al servidor
                                const arr = voices.map(v => ({ name: v.name, lang: v.lang }));
                                socket.emit('lista-voces', { arr, entidad }, (rpta) => {
                                    console.log(rpta);
                                });
                            });
                        } else {
                            audio.play();
                        }

                        // audio.play();
                    }

                    
                    //    if(asignados.length > 0 && minutosUltimo < 0.30 ) audio.play();
                }
                
                // if(asignados.length > 0 && minutosUltimo < 0.30 ) audio.play();

            })
            
        }
        fetchData();

        return () => {
            socket.off('ticket-asignado')
        }
    })

    
    useEffect(() => {

        // entidad= localStorage.getItem('entidad') || null;
        // if(entidad=== null) location.reload(); 
        
        // await getUltimos().then( tickets => setTickets(tickets) )
        const getUsers = async () => {
            const tickets = await getUltimos();
            console.log(tickets)
            setTickets(tickets);
            
            if( tickets.length > 0 ) {

                const hoy = new Date();
                const ultimo = new Date(tickets[0].atendidoEn);
                const diferenciaEnMinutos = (hoy - ultimo) / (1000 * 60);
                setMinutosUltimo( diferenciaEnMinutos );
                console.log( diferenciaEnMinutos )
                console.log( minutosUltimo )
            }

        };
    
        getUsers(); 
      
      
    }, [])

    // Oye si hay cambieos en parametros de la entidad
    // useEffect(() => {
    //     console.log( "respuesta" );

        
    //     // await getUltimos().then( tickets => setTickets(tickets) )
    //     const getEntidad = async () => {
    //         entidad= await localStorage.getItem('entidad') || null;
    //         if(entidad=== null) window.location.reload(); 
            
    //         socket.emit('registro-entidad', { codigoEntidad: entidad, r:2 },  async( respuesta ) => {
    //             console.log( respuesta );
    //             setLlamadoVoz( respuesta[0].llamadoVoz );
    //             localStorage.setItem('llamadoVoz', respuesta[0].llamadoVoz );
    //             entidad= respuesta[0].codigoEntidad;
            
    //         })



    //     };
    
    //     getEntidad(); 

    //     return () => {
    //         socket.off('registro-entidad')
    //     }
    // },[])
    
    const ingresar = () =>{


        let entidadB = document.getElementById('codigoEntidad');
        let codigoEntidad= entidadB.value;
        if(codigoEntidad === "") return UseSweetAlert("Atención!", 'Falta información', 'error');

        socket.emit('registro-entidad', { codigoEntidad },  async( respuesta ) => {
            if(respuesta.length === 0) return UseSweetAlert("Atención!", "Revise la información", "error");
            setEntidadBD( respuesta[0].codigoEntidad );
            setLlamadoVoz( respuesta[0].llamadoVoz );
            localStorage.setItem('entidad', respuesta[0].codigoEntidad);
            localStorage.setItem('llamadoVoz', respuesta[0].llamadoVoz );
            entidad= respuesta[0].codigoEntidad;

            const tickets = await getUltimos();
            setTickets(tickets);
            window.location.reload();

        
        })
    }   
    
  
    

    return (
        <>
            {
                entidad !== null ? 
                (
                    <div className=' px-3 vh-100 max-widtth-100'>

                      
                        <div className="row " style={{padding:"2px"}}>
                            
                            <div className="col-6 list-group ">
                                    <VideoPlayer videos = { videos.length ? videos.join(',') : videoList } />

                                
                               
                            </div>

                         

                            <div className="col-6 list-group" style={{fontSize:"12px"}}>

                                <table className="table table-borderless">
                                    <thead>
                                        <tr>
                                            <th className= "text-center fs-2" width="60%"> Turno </th>
                                            <th className= "text-center fs-2" width="40%"> Módulo </th>
                                        </tr>
                                    </thead>
                                    <tbody>
{
  tickets.slice(0,6).map((ticket, index) => {

    const textoModulo = `${ticket.moduloClase} ${ticket.modulo}`;
    const esMuyLargo = textoModulo.length > 24;
    const esLargo = textoModulo.length > 13;

    const fontSizeModulo = esMuyLargo ? 'fs-6' : esLargo ? 'fs-5' : 'fs-4';

    const color = (index === 0 && minutosUltimo < 0.10) ? "#f58733" : "#0098da";

    return (
      <tr key={index} className={index === 0 && minutosUltimo < 0.10 ? 'parpadea' : ''}>

        {/* TURNO */}
        <td width="60%">
          <span
            className="badge rounded-pill p-1"
            style={{
              width: "100%",
              height: "50px",
              backgroundColor: color,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center"
            }}
          >
            {
              ticket.nombrePaciente.trim() !== ""
              ? <span className='fs-5'>
                  {ticket.codigoTipoAtencion}-{ticket.numeroTicket} {ticket.nombrePaciente}
                </span>
              : <span className='fs-3'>
                  {ticket.codigoTipoAtencion}-{ticket.numeroTicket}
                </span>
            }
          </span>
        </td>

        {/* MODULO */}
        <td width="40%">
            <span
                className={`badge rounded-pill p-1 ${fontSizeModulo}`}
                style={{
                width: "100%",
                height: "50px",
                backgroundColor: color,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                padding: "2px"
                }}
            >
                <span
                style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    overflowWrap: "break-word",
                    width: "100%",
                    lineHeight: "1.1em",   // 🔥 importante
                    maxHeight: "2.2em"     // 🔥 CLAVE: 2 líneas reales
                }}
                >
                {textoModulo}
                </span>
            </span>
        </td>

      </tr>
    );
  })
}
</tbody>
                                    {/* <tbody>
                                        { 


                                            tickets.slice(0,6).map( (ticket, index) =>{
                                                
                                                if (index === 0 && minutosUltimo < 0.10 ){
                                                    return(
                                                        
                                                        <tr key={index} className= {`parpadea ${{ myAnimation: playAnimation }}  `}>
                                                            <td width="60%">
                                                                <span className= {`badge rounded-pill fs-2  `} style={{width: "100%", backgroundColor: "#f58733",}} >
                                                                    
                                                                    
                                                                    {   ticket.nombrePaciente.trim() !=="" 
                                                                        ? <span className='fs-5'> {ticket.codigoTipoAtencion}-{ticket.numeroTicket} {ticket.nombrePaciente} </span>
                                                                        : <span className='fs-2'> {ticket.codigoTipoAtencion}-{ticket.numeroTicket} </span> 
                                                                        
                                                                    }
                                                                </span>
                                                            </td>
                                                            <td width="40%">
                                                                <span className={`badge rounded-pill fs-3`} style={{width: "100%", backgroundColor: "#f58733"}} >
                                                                    <span className='fs-5'> {ticket.moduloClase} {ticket.modulo} </span>
                                                                </span>
                                                            </td>
                                                            
                                                        </tr>

                                                    )

                                                }else{

                                                    return(
                                                    
                                                        <tr key={index}>
                                                            <td width="60%">
                                                                <span className="badge rounded-pill fs-2" style={{width: "100%", backgroundColor: "#0098da"}} >
                                                                    {   ticket.nombrePaciente.trim() !=="" 
                                                                        ? <span className='fs-5'> {ticket.codigoTipoAtencion}-{ticket.numeroTicket} {ticket.nombrePaciente} </span>
                                                                        : <span className='fs-2'> {ticket.codigoTipoAtencion}-{ticket.numeroTicket} </span> 
                                                                        
                                                                    }
                                                                </span>
                                                            </td>



                                                            <td width="40%">
                                                                <span className="badge rounded-pill fs-2" style={{width: "100%", backgroundColor: "#0098da"}} >
                                                                    <span className='fs-5'> {ticket.moduloClase} {ticket.modulo} </span>
                                                                </span>
                                                            </td>
                                                            
                                                        </tr>

                                                    )

                                                }
                                            
                                                
                                            })
                                        }    
                                    </tbody> */}
                                </table>
                            
                            </div>

                            <div className='col-12' style={{padding:"0px"}}>
                                <div className="App">
                                    <Marquee />
                                </div>
                            </div>    

                          
                        </div>

                       

                    </div>

                ): (
                    <div className="row">
                    
                        <div className="d-flex justify-content-center mb-5">
                            <div className='d-grid gap-2 col-lg-3 col-12 mx-auto'>
                                
                                <div className='col-12'>
                                    <label htmlFor="codigoEntidad">Código Entidad</label>
                                    <input 
                                        type='text'
                                        id= 'codigoEntidad' 
                                        className='shadow form-control '
                                        autoComplete='off' 
                                        style={{ fontSize: 2+'em', textShadow: '2px 2px 8px #B8FFE9'}}
                                    /> 

                                </div>

                                <div className='d-grid gap-2'>
                                    <button className="btn btn-success btn-lg btn-block shadow" type="button" onClick={ () => ingresar()} >INGRESO</button>
                                </div>

                                
                            </div>
                        </div>
              

                    </div>
                    
                )

            }
        </>
    )
}
